import { isMdaeWidgetOptionChangeEvent, updateStateAfterWidgetOptionChange } from "../../mdae-framework";
import initialTargetedDenialAnalysisRootState from "./initial-states";
import { ITargetedDenialAnalysisRootState } from "./state-types";

// Professional
export const GET_TARGETED_DENIAL_ANALYSIS_PROFESSIONAL_REPORT_LIST = "GET_TARGETED_DENIAL_ANALYSIS_PROFESSIONAL_REPORT_LIST";
export const SET_INSIGHTID_AND_POPUP_TITLE_FROM_SELECTION_PROF = "SET_INSIGHTID_AND_POPUP_TITLE_FROM_SELECTION_PROF";
export const TOGGLE_TARGETED_DENIAL_ANALYSIS_PROF_REPORT_TABLE_POPUP = "TOGGLE_TARGETED_DENIAL_ANALYSIS_PROF_REPORT_TABLE_POPUP"
export const SET_PROFESSIONAL_AUDITS_COLUMN_LIST = "SET_PROFESSIONAL_AUDITS_COLUMN_LIST";
export const SET_PROFESSIONAL_SELECTED_AUDITS_LIST = "SET_PROFESSIONAL_SELECTED_AUDITS_LIST";
export const SET_PROF_AUDIT_CREATION_FOOTER_STATE = "SET_PROF_AUDIT_CREATION_FOOTER_STATE";
export const SET_TARGETED_DENIAL_ANALYSIS_REPORT_TABLE_POPUP_TITLE_PROF = "SET_TARGETED_DENIAL_ANALYSIS_REPORT_TABLE_POPUP_TITLE_PROF";
export const SET_REPORT_DATA_GRID_TOTAL_ROW_COUNT_TEXT_PROF = "SET_REPORT_DATA_GRID_TOTAL_ROW_COUNT_TEXT_PROF";
export const SET_REPORT_TABLE_SAMPLE_SIZE_PROF = "SET_REPORT_TABLE_SAMPLE_SIZE_PROF";
export const TOGGLE_REPORT_TABLE_SAMPLE_SIZE_NUMBER_BOX_PROF = "TOGGLE_REPORT_TABLE_SAMPLE_SIZE_NUMBER_BOX_PROF";
export const SET_PROF_SELECTED_AUDITS_PROVIDER_LIST = "SET_PROF_SELECTED_AUDITS_PROVIDER_LIST";
export const SET_PROF_REPORT_DATA_GRID_IS_DATA_SELECTED = "SET_PROF_REPORT_DATA_GRID_IS_DATA_SELECTED";
export const SET_PROF_REPORT_DATA_GRID_FILTER_EXPRESSION = "SET_PROF_REPORT_DATA_GRID_FILTER_EXPRESSION";
export const SET_PROF_REPORT_DATA_GRID_RECORDS_SELECTED_TEXT = "SET_PROF_REPORT_DATA_GRID_RECORDS_SELECTED_TEXT";
export const SET_PROF_REPORT_DATA_GRID_FILTERED_ROW_COUNT_TEXT = "SET_PROF_REPORT_DATA_GRID_FILTERED_ROW_COUNT_TEXT";
export const TOGGLE_TARGETED_DENIAL_ANALYSIS_PROF_WARNING_POPUP = "TOGGLE_TARGETED_DENIAL_ANALYSIS_PROF_WARNING_POPUP";

// Institutional
export const SET_INSIGHTID_AND_POPUP_TITLE_FROM_SELECTION_INST = "SET_INSIGHTID_AND_POPUP_TITLE_FROM_SELECTION_INST";
export const SET_REPORT_DATA_GRID_TOTAL_ROW_COUNT_TEXT_INST = "SET_REPORT_DATA_GRID_TOTAL_ROW_COUNT_TEXT_INST";
export const SET_INST_AUDIT_CREATION_FOOTER_STATE = "SET_INST_AUDIT_CREATION_FOOTER_STATE";
export const SET_INSTITUTIONAL_AUDITS_COLUMN_LIST = "SET_INSTITUTIONAL_AUDITS_COLUMN_LIST";
export const SET_INSTITUTIONAL_SELECTED_AUDITS_LIST = "SET_INSTITUTIONAL_SELECTED_AUDITS_LIST";
export const TOGGLE_TARGETED_DENIAL_ANALYSIS_INST_REPORT_TABLE_POPUP = "TOGGLE_TARGETED_DENIAL_ANALYSIS_INST_REPORT_TABLE_POPUP";
export const SET_REPORT_TABLE_SAMPLE_SIZE_INST = "SET_REPORT_TABLE_SAMPLE_SIZE_INST";
export const TOGGLE_REPORT_TABLE_SAMPLE_SIZE_NUMBER_BOX_INST = "TOGGLE_REPORT_TABLE_SAMPLE_SIZE_NUMBER_BOX_INST";
export const SET_INST_SELECTED_AUDITS_PROVIDER_LIST = "SET_INST_SELECTED_AUDITS_PROVIDER_LIST";
export const SET_INST_REPORT_DATA_GRID_IS_DATA_SELECTED = "SET_INST_REPORT_DATA_GRID_IS_DATA_SELECTED";
export const SET_INST_REPORT_DATA_GRID_FILTER_EXPRESSION = "SET_INST_REPORT_DATA_GRID_FILTER_EXPRESSION";
export const SET_INST_REPORT_DATA_GRID_RECORDS_SELECTED_TEXT = "SET_INST_REPORT_DATA_GRID_RECORDS_SELECTED_TEXT";
export const SET_INST_REPORT_DATA_GRID_FILTERED_ROW_COUNT_TEXT = "SET_INST_REPORT_DATA_GRID_FILTERED_ROW_COUNT_TEXT";
export const TOGGLE_TARGETED_DENIAL_ANALYSIS_INST_WARNING_POPUP = "TOGGLE_TARGETED_DENIAL_ANALYSIS_INST_WARNING_POPUP";


export const SET_TARGETED_DENIAL_ANALYSIS_WARNING_MESSAGE_INNER_HTML = "SET_TARGETED_DENIAL_ANALYSIS_WARNING_MESSAGE_INNER_HTML";




const initialState: ITargetedDenialAnalysisRootState = initialTargetedDenialAnalysisRootState;


export default function(state: ITargetedDenialAnalysisRootState = initialState, action) {
    
    let newState: ITargetedDenialAnalysisRootState; 
    
    switch (action.type) {
      
      case SET_PROFESSIONAL_AUDITS_COLUMN_LIST:
      case SET_PROFESSIONAL_SELECTED_AUDITS_LIST:
        newState = { ...state };
        if(action.data) {
          newState.targetedDenialAnalysisProfessionalPopupReportState = { ...newState.targetedDenialAnalysisProfessionalPopupReportState, ...action.data }
        }
        return newState;
      case SET_INSTITUTIONAL_AUDITS_COLUMN_LIST:
      case SET_INSTITUTIONAL_SELECTED_AUDITS_LIST:
        newState = { ...state };
        if(action.data) {
          newState.targetedDenialAnalysisInstitutionalPopupReportState = { ...newState.targetedDenialAnalysisInstitutionalPopupReportState, ...action.data }
        }
        return newState;
      case TOGGLE_TARGETED_DENIAL_ANALYSIS_PROF_REPORT_TABLE_POPUP:
        newState = {...state};
        if (isMdaeWidgetOptionChangeEvent(action.data)) {
          newState.targetedDenialAnalysisProfessionalPopupReportState = updateStateAfterWidgetOptionChange(newState.targetedDenialAnalysisProfessionalPopupReportState, action.data);
        } else {
          newState.targetedDenialAnalysisProfessionalPopupReportState = { ...newState.targetedDenialAnalysisProfessionalPopupReportState, ...action.data };
        }
        return newState;
      case TOGGLE_TARGETED_DENIAL_ANALYSIS_INST_REPORT_TABLE_POPUP:
        newState = {...state};
        if (isMdaeWidgetOptionChangeEvent(action.data)) {
          newState.targetedDenialAnalysisInstitutionalPopupReportState = updateStateAfterWidgetOptionChange(newState.targetedDenialAnalysisInstitutionalPopupReportState, action.data);
        } else {
          newState.targetedDenialAnalysisInstitutionalPopupReportState = { ...newState.targetedDenialAnalysisInstitutionalPopupReportState, ...action.data };
        }
        return newState;
      case TOGGLE_REPORT_TABLE_SAMPLE_SIZE_NUMBER_BOX_PROF:
      case SET_REPORT_TABLE_SAMPLE_SIZE_PROF:
        newState = {...state};
        if (isMdaeWidgetOptionChangeEvent(action.data)) {
          newState.targetedDenialAnalysisProfessionalPopupReportState.popupFooterState = updateStateAfterWidgetOptionChange(
            newState.targetedDenialAnalysisProfessionalPopupReportState.popupFooterState, action.data);
        } else {
          newState.targetedDenialAnalysisProfessionalPopupReportState.popupFooterState = { 
            ...newState.targetedDenialAnalysisProfessionalPopupReportState.popupFooterState, ...action.data };
        }
        return newState;

      case TOGGLE_REPORT_TABLE_SAMPLE_SIZE_NUMBER_BOX_INST:
      case SET_REPORT_TABLE_SAMPLE_SIZE_INST:
        newState = {...state};
        if (isMdaeWidgetOptionChangeEvent(action.data)) {
          newState.targetedDenialAnalysisInstitutionalPopupReportState.popupFooterState = updateStateAfterWidgetOptionChange(
            newState.targetedDenialAnalysisInstitutionalPopupReportState.popupFooterState, action.data);
        } else {
          newState.targetedDenialAnalysisInstitutionalPopupReportState.popupFooterState = { 
            ...newState.targetedDenialAnalysisInstitutionalPopupReportState.popupFooterState, ...action.data };
        }
        return newState;
      

      case TOGGLE_TARGETED_DENIAL_ANALYSIS_PROF_WARNING_POPUP:
        newState = {...state};
        if (isMdaeWidgetOptionChangeEvent(action.data)) {
          newState.targetedDenialAnalysisProfessionalPopupReportState.warningPopupState = updateStateAfterWidgetOptionChange(
            newState.targetedDenialAnalysisProfessionalPopupReportState.warningPopupState, action.data);
        } else {
          newState.targetedDenialAnalysisProfessionalPopupReportState.warningPopupState = { 
            ...newState.targetedDenialAnalysisProfessionalPopupReportState.warningPopupState, ...action.data };
        }
        return newState;

      case TOGGLE_TARGETED_DENIAL_ANALYSIS_INST_WARNING_POPUP:
        newState = {...state};
        if (isMdaeWidgetOptionChangeEvent(action.data)) {
          newState.targetedDenialAnalysisInstitutionalPopupReportState.warningPopupState = updateStateAfterWidgetOptionChange(
            newState.targetedDenialAnalysisInstitutionalPopupReportState.warningPopupState, action.data);
        } else {
          newState.targetedDenialAnalysisInstitutionalPopupReportState.warningPopupState = { 
            ...newState.targetedDenialAnalysisInstitutionalPopupReportState.warningPopupState, ...action.data };
        }
        return newState;

      case SET_TARGETED_DENIAL_ANALYSIS_REPORT_TABLE_POPUP_TITLE_PROF:
        newState = { ...state };
        if(action.data) {
          newState.targetedDenialAnalysisProfessionalPopupReportState.reportTablePopupTitle = action.data.professionalReportTablePopupTitle;
        }
        return newState;
        
      case SET_INSIGHTID_AND_POPUP_TITLE_FROM_SELECTION_PROF:
        newState = { ...state };
        if(action.data) {
          newState.targetedDenialAnalysisProfessionalPopupReportState.selectedInsightIdForProfessional = action.data.selectedInsightIdForProfessional;
          newState.targetedDenialAnalysisProfessionalPopupReportState.reportTablePopupTitle = action.data.professionalReportTablePopupTitle;
        }
        return newState;
      
      case SET_INSIGHTID_AND_POPUP_TITLE_FROM_SELECTION_INST:
        newState = { ...state };
        if(action.data) {
          newState.targetedDenialAnalysisInstitutionalPopupReportState.selectedInsightIdForInstitutional = action.data.selectedInsightIdForInstitutional;
          newState.targetedDenialAnalysisInstitutionalPopupReportState.reportTablePopupTitle = action.data.institutionalReportTablePopupTitle;
        }
        return newState;

      case SET_TARGETED_DENIAL_ANALYSIS_WARNING_MESSAGE_INNER_HTML:
        newState = { ...state };
        if(action.data) {
          newState.targetedDenialAnalysisWarningMessageInnerHtml = action.data.targetedDenialAnalysisWarningMessageInnerHtml;
        }
        return newState;

      case SET_PROF_SELECTED_AUDITS_PROVIDER_LIST:
        newState = { ...state };
        if(action.data) {
          newState.targetedDenialAnalysisProfessionalPopupReportState.selectedAuditsProvider = action.data.selectedAuditsProvider;
        }
        return newState;

      case SET_INST_SELECTED_AUDITS_PROVIDER_LIST:
        newState = { ...state };
        if(action.data) {
          newState.targetedDenialAnalysisInstitutionalPopupReportState.selectedAuditsProvider = action.data.selectedAuditsProvider;
        }
        return newState;

      case SET_PROF_AUDIT_CREATION_FOOTER_STATE:
        newState = { ...state };
        if(action.data) {
          newState.targetedDenialAnalysisProfessionalPopupReportState.popupFooterState 
          = { ...newState.targetedDenialAnalysisProfessionalPopupReportState.popupFooterState, ...action.data };
        }
        return newState;

      case SET_INST_AUDIT_CREATION_FOOTER_STATE:
        newState = { ...state };
        if(action.data) {
          newState.targetedDenialAnalysisInstitutionalPopupReportState.popupFooterState 
          = { ...newState.targetedDenialAnalysisInstitutionalPopupReportState.popupFooterState, ...action.data };
        }
        return newState;
      
      case SET_PROF_REPORT_DATA_GRID_IS_DATA_SELECTED:
        newState = { ...state };
        if(action.data) {
          newState.targetedDenialAnalysisProfessionalPopupReportState.popupContentState.isDataSelected = action.data.isDataSelected;
        }
        return newState;

      case SET_INST_REPORT_DATA_GRID_IS_DATA_SELECTED:
        newState = { ...state };
        if(action.data) {
          newState.targetedDenialAnalysisInstitutionalPopupReportState.popupContentState.isDataSelected = action.data.isDataSelected;
        }
        return newState;

      case SET_PROF_REPORT_DATA_GRID_FILTER_EXPRESSION:
        newState = { ...state };
        if(action.data) {
          newState.targetedDenialAnalysisProfessionalPopupReportState.popupContentState.filterExpression = action.data.filterExpression;
        }
        return newState;

      case SET_INST_REPORT_DATA_GRID_FILTER_EXPRESSION:
        newState = { ...state };
        if(action.data) {
          newState.targetedDenialAnalysisInstitutionalPopupReportState.popupContentState.filterExpression = action.data.filterExpression;
        }
        return newState;
      
      case SET_PROF_REPORT_DATA_GRID_RECORDS_SELECTED_TEXT:
        newState = { ...state };
        if(action.data) {
          newState.targetedDenialAnalysisProfessionalPopupReportState.popupContentState.recordsSelectedText = action.data.recordsSelectedText;
        }
        return newState;
      
      case SET_INST_REPORT_DATA_GRID_RECORDS_SELECTED_TEXT:
        newState = { ...state };
        if(action.data) {
          newState.targetedDenialAnalysisInstitutionalPopupReportState.popupContentState.recordsSelectedText = action.data.recordsSelectedText;
        }
        return newState;
          
      case SET_PROF_REPORT_DATA_GRID_FILTERED_ROW_COUNT_TEXT:
        newState = { ...state };
        if(action.data) {
          newState.targetedDenialAnalysisProfessionalPopupReportState.popupContentState.filteredRowCountText = action.data.filteredRowCountText;
        }
        return newState;

      case SET_INST_REPORT_DATA_GRID_FILTERED_ROW_COUNT_TEXT:
        newState = { ...state };
        if(action.data) {
          newState.targetedDenialAnalysisInstitutionalPopupReportState.popupContentState.filteredRowCountText = action.data.filteredRowCountText;
        }
        return newState;

      case SET_REPORT_DATA_GRID_TOTAL_ROW_COUNT_TEXT_PROF:
        newState = { ...state };
        if(action.data) {
          newState.targetedDenialAnalysisProfessionalPopupReportState.popupContentState.totalRowCountText = action.data.totalRowCountText;
        }
        return newState;

      case SET_REPORT_DATA_GRID_TOTAL_ROW_COUNT_TEXT_INST:
        newState = { ...state };
        if(action.data) {
          newState.targetedDenialAnalysisInstitutionalPopupReportState.popupContentState.totalRowCountText = action.data.totalRowCountText;
        }
        return newState;

      default:
        return state;
    }
}